import Vue from 'vue';
import msal from 'vue-msal';
import axios from 'axios';
import AuthenticationService from '../domain/security/authentication.service';

const PUBLIC_URLS = ['/api/v1/actuator/health'];

Vue.use(msal, {
  auth: {
    tenantId: process.env.VUE_APP_TENANT_ID,
    clientId: process.env.VUE_APP_CLIENT_ID,
    redirectUri: process.env.VUE_APP_REDIRECT_URL,
    autoRefreshToken: true,
  },
});

axios.interceptors.request.use(
  async (config: any) => {
    const token: string = await AuthenticationService.token();
    const newConfig: any = {};
    Object.assign(newConfig, config);
    if (!PUBLIC_URLS.includes(config.url)) {
      newConfig.headers.Authorization = `Bearer ${token}`;
    }
    return newConfig;
  },
);
